const urlBreakdown = {
  domain: 'https://cataas.com/cat',
  textParam: '/says/',
  fontParam: '?fontSize=50&fontColor=%23FFF',
  jsonParam: '&json=true'
};

export default urlBreakdown;
